module.exports = __webpack_public_path__ + "static/media/second.d5289148.jpg";